import * as Sentry from '@sentry/vue'

export default class SentrySingleton {
    private static _instance?: SentrySingleton;

    private constructor() {
        if (SentrySingleton._instance)
            throw new Error("Use Singleton.instance instead of new.");
        SentrySingleton._instance = this;
    }


    static get instance() {
        return SentrySingleton._instance ?? (SentrySingleton._instance = new SentrySingleton());
    }

    captureException(exception: any) {
        Sentry.captureException(exception)
        console.error(exception)
    }

    captureMessage(message: string) {
        Sentry.captureMessage(message)
        console.error(message)
    }
}

